import { Grid, Dialog, Button, DialogContent } from '@mui/material'
import { PDFViewer } from '@react-pdf/renderer'
import PdfProposta from '../../../utils/pdfComponets/pdfProposta'

const ModalPdf = ({
  data: {
    proposta,
    contratante,
    suite,
    checkIn,
    checkOut,
    pessoas,
    pacotes,
    terapias,
    subTotal,
    caucao,
    total,
    observacoes,
  },
  close,
}) => {
  const handleFalse = () => {
    close(false)
  }

  for (const c of observacoes) {
    console.log(c, c.codePointAt(0))
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={true} onClose={handleFalse}>
      <DialogContent>
        <Grid container spacing={2} style={{ padding: 0 }}>
          <Grid item xs={12}>
            <PDFViewer width="100%" height="600px">
              <PdfProposta
                {...{
                  proposta,
                  contratante,
                  suite,
                  checkIn,
                  checkOut,
                  pessoas,
                  pacotes,
                  terapias,
                  subTotal,
                  caucao,
                  total,
                  observacoes,
                }}
              />
            </PDFViewer>
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" onClick={handleFalse}>
              fechar
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalPdf
